<div tabindex="-1"
     [tdWbFocus]="calendarFocusEventEmitter | async"
     class="td-wb-date-picker-inner-container">
  <ng-content />
</div>
